var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
import * as i0 from "@angular/core";
var defaultSortParam = '';
var defaultSortDirection = '';
var AnulacionZonaAzulAutoFilterService = /** @class */ (function (_super) {
    __extends(AnulacionZonaAzulAutoFilterService, _super);
    function AnulacionZonaAzulAutoFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnulacionZonaAzulAutoFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('fechaInicio', filter.fechaInicio.toJSON())
            .append('fechaFin', filter.fechaFin.toJSON())
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    AnulacionZonaAzulAutoFilterService.prototype.createParamsFromSelectedItems = function (selectedItems) {
        return new HttpParams().append('listaExpedients', JSON.stringify(selectedItems));
    };
    AnulacionZonaAzulAutoFilterService.ngInjectableDef = i0.defineInjectable({ factory: function AnulacionZonaAzulAutoFilterService_Factory() { return new AnulacionZonaAzulAutoFilterService(); }, token: AnulacionZonaAzulAutoFilterService, providedIn: "root" });
    return AnulacionZonaAzulAutoFilterService;
}(CustomFilterService));
export { AnulacionZonaAzulAutoFilterService };
